import { apiClient, WHOLE_USE_MOCK } from "./api";
import { menuTree } from "../mock/mockMenuData";
import { API_ENDPOINTS } from "../utils/apiEndpoints";

class MenuService {
  /**
   * 获取菜单树（分页+条件）
   */
  async getMenuTree(params) {
    if ((await apiClient.getMock()) && WHOLE_USE_MOCK) {
      // 可根据params做简单过滤

      return {
        traceId: "mock-trace-id",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: menuTree,
      };
    } else {
      const { appDomain, currentPage, pageSize } = params;
      let resp = await apiClient.get(
        API_ENDPOINTS.MENU.TREE +
          "?appDomain=" +
          appDomain +
          "&currentPage=" +
          currentPage +
          "&pageSize=" +
          pageSize
      );
      return resp;
    }
  }

  /**
   * 创建菜单
   */
  async createMenu(data) {
    if ((await apiClient.getMock()) && WHOLE_USE_MOCK) {
      // 可根据params做简单过滤
      return {
        traceId: "mock-trace-id",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: menuTree,
      };
    } else {
      return apiClient.post(API_ENDPOINTS.MENU.CREATE, data);
    }
  }
}

export const menuService = new MenuService();
